import React, { Fragment } from 'react';
import { styled } from 'linaria/react';

import Accordion from '@jetshop/ui/Accordion/Accordion';
import { theme } from '../Theme';

export const CenterBlock = styled('div')``;

const AccordionItemBlock = styled('div')`
  border-bottom: 1px solid #e4e4e4;
  margin: 1rem 0;
  font-size: 0.875rem;

  max-width: 700px;
  margin: auto;

  > div {
    text-align: left;
    padding: 0 10px;
    ${theme.below.lg} {
      padding: 0 20px;
    }
  }
  > div > h2 {
    font-size: 1rem;
    margin: 0;
    line-height: 1;
    letter-spacing: 0.5px;
  }

  p {
    margin-bottom: 1rem !important;
  }
`;

const AccordionTitle = styled('div')`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: 1rem 10px !important;
  span {
    line-height: 1;
  }
  ${theme.below.lg} {
    padding: 1rem 20px !important;
  }
`;

const IndicatorIcon = styled('span')`
  font-size: 1.25rem;
  margin: 0;
  ${theme.below.lg} {
    width: 30px;
    text-align: right;
  }
`;

const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? '-' : '+'}</IndicatorIcon>
);

export const AccordionItem = ({
  children,
  title,
  index,
  openIndexes,
  handleClick,
  AccordionContent
}) => (
  <AccordionItemBlock key={index}>
    <AccordionTitle onClick={() => handleClick(index)}>
      <h2>{title}</h2>
      <AccordionIndicator isOpen={openIndexes.includes(index)} />
    </AccordionTitle>

    <AccordionContent
      className="accordion-content"
      isOpen={openIndexes.includes(index)}
    >
      {children}
    </AccordionContent>
  </AccordionItemBlock>
);

const ContentAccordion = ({ children }) => (
  <Accordion single>
    {({ openIndexes, handleClick, AccordionContent }) => (
      <Fragment>
        {children?.map((child, index) => (
          <AccordionItem
            key={index}
            openIndexes={openIndexes}
            handleClick={handleClick}
            AccordionContent={AccordionContent}
            children={child.props.children}
            title={child.props.title}
            index={index}
          />
        ))}
      </Fragment>
    )}
  </Accordion>
);

export default ContentAccordion;
